import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { STATION_REPAIR_STEUP, CREATE_STATION_REPAIR } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import AddStationRepairForm from "../forms/AddStationRepairForm";

export const AddStationRepairPage = () => {
  const navigate = useNavigate();
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  useEffect(() => {
    getData(STATION_REPAIR_STEUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // API calling
    executePost(formValues, CREATE_STATION_REPAIR, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Station Repair" }}>
      {isLoaded && !error ? (
        <AddStationRepairForm
          setup={data}
          sendData={sendData}
          successResponse={successResponse}
          loading={loading}
          navigate={navigate}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
